import {Datagrid} from 'components/refinedev/Datagrid';
import {ColumnDef, createColumnHelper} from '@tanstack/react-table';
import {LiveSearchFilter} from 'components/refinedev/filter-forms/LiveSearchFilter';
import {
  CreateButton,
  DeleteButtonWithConfirmation,
  EditButton,
} from 'components/refinedev/action_buttons';
import {defaultQueryOptions} from 'pages/_utils';
import {BaseRecord, HttpError, useTable} from '@refinedev/core';
import StateBoundary from '@/components/basic/StateBoundary';
import {DataTable} from '@/components/data-table/data-table';
import {DataTableColumnHeader} from '@/components/data-table/data-table-column-header';
import DefaultDataTableToolbar from '@/components/refinedev/data-table/DefaultDataTableToolbar';
import useRefineTanstackDataTable from '@/hooks/refinedev/useRefineTanstackDataTable';

const thisResource = 'roles';

const columnHelper = createColumnHelper<any>();

const columns = [
  columnHelper.accessor('id', {
    meta: {label: 'ID'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.getValue(),
  }),
  columnHelper.accessor('name', {
    meta: {label: 'Tên'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.accessor('desc', {
    meta: {label: 'Mô tả'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => info.renderValue(),
  }),
  columnHelper.display({
    id: 'actions',
    meta: {label: 'Hành động'},
    header: ({column}) => <DataTableColumnHeader column={column} />,
    cell: info => (
      <div className="flex flex-row">
        <EditButton id={String(info.row.getValue('id'))} resource={thisResource} />
        <DeleteButtonWithConfirmation
          id={String(info.row.getValue('id'))}
          resource={thisResource}
        />
      </div>
    ),
  }),
];

const RoleList = () => {
  const {refineTable, tanstackTable} = useRefineTanstackDataTable(
    {
      resource: thisResource,
      sorters: {initial: [{field: 'id', order: 'asc'}]},
      queryOptions: defaultQueryOptions,
    },
    {columns},
  );

  return (
    <StateBoundary
      isLoading={refineTable.tableQuery.isLoading}
      error={refineTable.tableQuery.error}>
      <div className="p-2">
        <DataTable
          table={tanstackTable}
          toolbar={
            <DefaultDataTableToolbar
              resource={thisResource}
              table={tanstackTable}
              // bulkActions={[bulkDelete]}
            />
          }
        />
      </div>
    </StateBoundary>
  );
};

RoleList.table_columns = columns;

export default RoleList;
